import { drawText } from "../text";
import type { DrawContext } from "../text";

/** Başlık ekranındaki büyük piksel yılan logosu (S şekli, 1 = dolu blok). */
const LOGO: readonly string[] = [
  "1111111110",
  "1000000001",
  "1111111101",
  "1000000001",
  "1011111111",
  "1010000000",
  "1011111110",
  "1000000010",
  "1111111011",
  "0000000111",
];

export function drawTitle(rc: DrawContext, padConnected: boolean): void {
  const { ctx, layout } = rc;
  const { width, height } = layout;
  // Logo ekranın ~%40 yüksekliğini ve ~%55 genişliğini geçmesin → yazılar taşmaz.
  const bs = Math.max(8, Math.floor(Math.min((width * 0.55) / LOGO[0].length, (height * 0.4) / LOGO.length)));

  const ox = (width - LOGO[0].length * bs) / 2;
  const oy = height * 0.1;
  ctx.fillStyle = "#20301a";
  for (let y = 0; y < LOGO.length; y++) {
    for (let x = 0; x < LOGO[y].length; x++) {
      if (LOGO[y][x] === "1") {
        ctx.fillRect(ox + x * bs + 1, oy + y * bs + 1, bs - 2, bs - 2);
      }
    }
  }

  // Başlık ve alt başlık logoya göre konumlanır.
  const logoBottom = oy + LOGO.length * bs;
  const titleY = logoBottom + bs * 1.4;
  drawText(rc, "YILAN", width / 2, titleY, Math.floor(bs * 0.9));
  drawText(rc, "3310 EDITION", width / 2, titleY + bs * 1.1, Math.floor(bs * 0.45));

  if (isBlinking(1.5)) {
    drawText(rc, "BASLAMAK ICIN  A / ENTER", width / 2, height * 0.72, Math.floor(bs * 0.45));
  }

  drawText(rc, "KLAVYE : OK TUSLARI / WASD", width / 2, height * 0.8, Math.floor(bs * 0.33));
  drawText(rc, "PAD    : DPAD / ANALOG", width / 2, height * 0.8 + bs * 0.55, Math.floor(bs * 0.33));
  drawText(rc, "F : TAM EKRAN   M : SES", width / 2, height * 0.8 + bs * 1.2, Math.floor(bs * 0.33));

  drawText(
    rc,
    padConnected ? "> KOL BAGLI <" : "KOL BEKLENIYOR...",
    width / 2,
    height * 0.93,
    Math.floor(bs * 0.33),
  );
}

/** Zaman bazlı yanıp sönme: `rate` saniyede bir açılıp kapanır. */
export function isBlinking(rate: number, time = performance.now() / 1000): boolean {
  return Math.floor(time * rate) % 2 === 0;
}
